import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sub-header',
  templateUrl: './sub-header.component.html',
  styleUrls: ['./sub-header.component.scss']
})
export class SubHeaderComponent {
  @Input() pageTitle: string = '';
  public boxHeight: string = 'auto';

  constructor(private router: Router) {} 

  navigateToHome() {
    this.router.navigate(['/']);  
  }

  refreshPage() {
    window.location.reload();  
  }
}
